// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".anonymous-help-text {\n    color: red;\n    padding-left: 5px;\n}", ""]);
// Exports
module.exports = exports;
